<template>
  <v-menu
    ref="menu"
    v-model="ageMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="customerAgeDob"
        label="Date of Birth"
        readonly
        outlined
        :rules="rules"
        background-color="#fff"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      :active-picker.sync="activePicker"
      v-model="date"
      :max="new Date().toISOString().substr(0, 10)"
      min="1950-01-01"
      @change="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  props: {
    value: { type: String, default: null },
    rules: { type: Array, default: () => [] },
  },
  data() {
    return {
      ageMenu: false,
      date: null,
      activePicker: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val == null) this.date = null;
        if (val != this.date) {
          this.date = val;
        }
      },
    },
    ageMenu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  computed: {
    customerAgeDob() {
      if (this.date == null) return null;
      let age = moment().diff(this.date, "years");
      let dob = moment(this.date, "YYYY-MM-DD").format("Do MMM YYYY");
      return `${dob} (${age})`;
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.$emit("input", date);
    },
  },
};
</script>

<style>
</style>